import clsx from "clsx";
import { useCallback, useContext, useEffect, useState, useRef } from "react";
import { LocaleContext } from "./localization_wrapper";
import { STATEMENTS } from "../statements";

export function TellitPage({ handleSave, children, className, page }) {
  const statement = page.treesponse.getAnswer("statement");
  const i18n = useContext(LocaleContext);
  const formRef = useRef(null);
  const tellitRef = useRef(null);

  useEffect(() => {
    if (formRef.current === null) return;

    if (page.treesponse.getAnswer("opinion") !== undefined) {
      const callback = () => setTimeout(scrollToForm, 25);
      tellitRef.current?.addEventListener("tellit:loaded", callback, {
        once: true,
      });
      scrollToForm();

      return () =>
        tellitRef.current?.removeEventListener("tellit:loaded", callback, {
          once: true,
        });
    }
  }, [formRef]);

  function scrollToForm() {
    formRef.current.scrollIntoView({ behaviour: "instant", block: "start" });
  }

  return (
    <>
      <ScrollIndicator />
      <tellit-player
        data-story-url={`https://tell-it-production-public.s3.eu-central-1.amazonaws.com/${STATEMENTS[statement].tellit[i18n.locale]}/story.json`}
        ref={tellitRef}
      ></tellit-player>
      <form
        action=""
        onSubmit={handleSave}
        className={clsx(className, "tellit-form")}
        ref={formRef}
      >
        <div className="tellit-form__container">{children}</div>
      </form>
    </>
  );
}

const SCROLL_INDICATOR_UNTIL = 250;

function ScrollIndicator({ className }) {
  const [hidden, setHidden] = useState(window.scrollY > SCROLL_INDICATOR_UNTIL);
  const i18n = useContext(LocaleContext);

  const onScroll = useCallback(() => {
    setHidden(window.scrollY > SCROLL_INDICATOR_UNTIL);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [onScroll]);

  return (
    <div className={clsx("scroll-indicator", className)} hidden={hidden}>
      <p className="scroll-indicator__text">{i18n.t("general.scroll_down")}</p>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="currentColor"
        className="scroll-indicator__icon"
        aria-hidden="true"
      >
        <path d="M8.00024 12.696L4.00024 8.69603L4.93358 7.7627L8.00024 10.8127L11.0669 7.7627L12.0002 8.69603L8.00024 12.696ZM8.00024 8.69603L4.00024 4.69603L4.93358 3.7627L8.00024 6.8127L11.0669 3.7627L12.0002 4.69603L8.00024 8.69603Z" />
      </svg>
    </div>
  );
}
